import { MicrophoneStreamError } from '../../constants/microphoneStream'
import { SpeechToTextError } from '../../constants/speechToText'
import { DeepgramWebSocketError } from '../useDeepgramWebSocket'

export const DEEPGRAM_LIVE_URL = 'wss://api.deepgram.com/v1/listen'

export const DEEPGRAM_LIVE_QUERY = {
  endpointing: '300',
  interim_results: 'true',
  language: 'multi',
  model: 'nova-3',
  punctuate: 'true',
  smart_format: 'true',
  vad_events: 'false',
}

export const SPEECH_TO_TEXT_DRAIN_TIMEOUT_MS = 1000

export const DeepgramMessageType = {
  CloseStream: 'CloseStream',
  Results: 'Results',
}

export const MICROPHONE_STREAM_ERROR_TO_SPEECH_TO_TEXT_ERROR = {
  [MicrophoneStreamError.PermissionDenied]:
    SpeechToTextError.MicrophonePermissionDenied,
  [MicrophoneStreamError.RecorderUnsupported]:
    SpeechToTextError.RecorderUnsupported,
  [MicrophoneStreamError.Unavailable]: SpeechToTextError.MicrophoneUnavailable,
}

export const DEEPGRAM_WEB_SOCKET_ERROR_TO_SPEECH_TO_TEXT_ERROR = {
  [DeepgramWebSocketError.ConfigError]: SpeechToTextError.ConfigError,
  [DeepgramWebSocketError.ConnectionError]: SpeechToTextError.ConnectionError,
  [DeepgramWebSocketError.QuotaError]: SpeechToTextError.QuotaError,
  [DeepgramWebSocketError.ServiceError]: SpeechToTextError.ServiceError,
}
